<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-6" xl="5">
                        <div class="font-weight-bold body-1">
                            Editar ingreso
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="6" xl="5">
                        <v-form ref="form" @submit.prevent="save">
                            <deposit-form ref="DepositForm" :values="form" @save="save" :serverErrors="serverErrors"></deposit-form>
                        </v-form>
                    </v-col>
                    
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="6" xl="5" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../helpers/Utils';
import DepositForm from "./Form.vue";
import Object2Form from "../../helpers/Object2Form";
export default {
    components: {
        'deposit-form': DepositForm,
    },
	data(){
		return {
            slug: this.$route.params.slug,
            loading: false,
            serverErrors: {},
            form: {
                type: "INCOME",
                date: '',
                name: "",
                concept_id: "",
                target_account_id: '',
                payment_method_id: "",
                subtotal: "",
                taxes: "",
                total: "",
                currency: "",
                bank_account_id: "",
                reference_id: "",
                commentary: "",
                vaucher: "",
                vaucher_file: [],

                //new files to upload
                files: [],
                //files urls
                files_urls:[],
                //files to delete
                files_delete:[]
                    
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Deposits",
                block:false,	
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar cambios",
                icon: "mdi-content-save-outline",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        this.index();
    },
	methods: {
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
			return this.$refs.form.validate();
            // return true;
		},
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
        index()
        {
            this.loading = true;
            this.$store.state.loading = true;
            this.$api.deposit.get(this.$store.state.business, this.slug)
                .then((resp) => {
                    this.form = {
                        ...resp.data,
                        target_account_id: resp.data.target_account?.slug??'',
                        concept_id: resp.data.concept?.slug??'',
                        payment_method_id: resp.data.payment_method?.slug??'',
                        bank_account_id: resp.data.bank_account?.slug??'',
                        reference_id: resp.data.reference?.slug??'',
                        vaucher: resp.data.vaucher_url,
                        vaucher_file: [],

                        files_urls: [],
                        files_delete:[]
                    };

                    //files
                    this.form.files = [];
                    resp.data.files.forEach(f => {
                        const fileNameArr = f.file_path.split("/");
                        this.form.files_urls.push({...f, name: fileNameArr[fileNameArr.length - 1]});
                    });
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                    this.$store.state.loading = false;
                })
        },
        save(){
            
            //console.log(this.form);
            
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                console.log(form);
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                this.$api.deposit.update(this.$store.state.business,this.slug, form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha actualizado correctamente`);
                        this.$router.push({name: 'Deposits'});
                    })
                    .catch((error) => {
                        let errors = [];
                        switch(error.response.status){
                            case 422: 
                                
                                if(("error" in error.response.data)){
                                    if(error.response.data.error instanceof Object){
                                        Object.keys(error.response.data.error).forEach((x) => {
                                            
                                               
                                            console.log(x);
                                            this.serverErrors = error.response.data.error;
                                            error.response.data.error[x].forEach((y) => {
                                                this.serverErrors[x] = Utils.deleteWord(x,y);
                                                errors.push(Utils.deleteWord(x,y))
                                            })
                                        });
                                    }else{
                                        errors.push(error.response.data.error)
                                    }
                                    
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }
                        console.log(this.serverErrors)
                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },

        prepareRequest(request)
        {
            let data = JSON.parse(JSON.stringify(request));
            // data.vaucher_file = request.vaucher_file;
            delete data.bank_account;
            delete data.target_account;
            delete data.payment_method;
            delete data.concept;
            delete data.reference;
            delete data.target_account;

            //files
            data.files = [];
            for (let i = 0; i < request.files.length; i++) {
                data.files.push({file:request.files[i]});              
            }
            delete data.files_urls;


            console.log(data);
            return Object2Form.objectToFormData(data,'',[]);
        }
    },
}
</script>

<style>

</style>